import React, { FC } from "react"
import { Container } from "@components/wrapper"
import Socmed from "@components/footer/Socmed"
import FormColumn from "./FormColumn"
import { Heading } from "@components/typography"
import clsx from "clsx"

export const ContactUs: FC = () => {
  return (
    <section className={clsx("relative bg-white-f9 sm:py-15 sm:mt-15", "mt-10 py-10")}>
      <div id="#contactUs" className="absolute -top-15" />
      <Container className="sm:flex">
        <div className="sm:w-[45%] sm:my-auto mb-6">
          <Heading headingLevel="title" className="mb-1 text-blue">
            Hubungi Kami
          </Heading>
          <p className="text-black-67 sm-only:text-xs sm:w-3/5">
            Isi form dan kami akan menghubungi anda secepat mungkin
          </p>

          <h6 className={clsx("font-semibold sm:text-lg sm:mb-3 mt-4", "text-sm mb-2")}>
            Follow Us
          </h6>
          <Socmed color="#424242" outline="border-gray-a8" />
        </div>

        <div className="sm:w-[55%]">
          <FormColumn />
        </div>
      </Container>
    </section>
  )
}
